
import React from 'react';

const WhyChooseUsSection: React.FC = () => {
  return (
    <section id="why-choose-us" className="section-padding bg-itmgmt-light-gray">
      <div className="container-wide">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="heading-lg text-itmgmt-dark-blue mb-6">Why Choose IT Management Solutions?</h2>
            <p className="text-lg text-gray-700 mb-8">
              We understand that technology should enable your business, not hinder it. 
              Our approach is designed to provide you with reliable, secure, and efficient IT systems.
            </p>
            
            <div className="space-y-6">
              <div className="flex">
                <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                  <span className="text-white font-bold">1</span>
                </div>
                <div>
                  <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Proactive Support</h3>
                  <p className="text-gray-600">
                    We identify and resolve issues before they impact your business, 
                    preventing downtime and productivity loss.
                  </p>
                </div>
              </div>
              
              <div className="flex">
                <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                  <span className="text-white font-bold">2</span>
                </div>
                <div>
                  <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Transparent Pricing</h3>
                  <p className="text-gray-600">
                    Our flat-rate pricing model ensures predictable IT expenses with no 
                    surprise bills or hidden fees.
                  </p>
                </div>
              </div>
              
              <div className="flex">
                <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                  <span className="text-white font-bold">3</span>
                </div>
                <div>
                  <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Rapid Response</h3>
                  <p className="text-gray-600">
                    When issues do arise, our team responds quickly to minimize 
                    disruption to your business operations.
                  </p>
                </div>
              </div>
              
              <div className="flex">
                <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                  <span className="text-white font-bold">4</span>
                </div>
                <div>
                  <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Industry Expertise</h3>
                  <p className="text-gray-600">
                    We understand the unique IT challenges of your industry and provide 
                    tailored solutions that address your specific needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="order-first lg:order-last">
            <img 
              src="https://images.unsplash.com/photo-1483058712412-4245e9b90334?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
              alt="Modern IT workspace" 
              className="rounded-lg shadow-lg"
              width="800"
              height="533"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
